import { useAuth } from "hooks/useAuth";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";
import LeftNavigation from "components/Navigation/LeftNavigation";
import OnboardingHeader from "components/Header/OnboardingHeader";
import useIsMobile from "hooks/useIsMobile";

const RootLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const authContext = useAuth();
  const { pathname } = useLocation();
  const isMobile = useIsMobile();

  // This is used as react router is keeping scroll position persisted while we navigate between the routes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const isOnboardingOrSignupPage =
    pathname.includes("/onboarding-business") || pathname.includes("/sign-up");

  return (
    <div className="bg-offWhite min-h-screen overflow-x-hidden">
      <Toaster />
      {!!authContext?.user ? (
        <>
          {isOnboardingOrSignupPage ? (
            // Onboarding/Signup Flow - Show only header, no left navigation
            <div className="min-h-screen flex flex-col bg-white">
              <OnboardingHeader />
              <div className="flex-1 bg-white">
                {children}
              </div>
            </div>
          ) : (
            // Regular authenticated pages - Show full left navigation
            <div className={`${isMobile ? 'flex flex-col' : 'flex'} min-h-screen relative`}>
              {/* Left Navigation Sidebar / Mobile Header */}
              <LeftNavigation />
              
              {/* Main Content Area */}
              <div className={`flex-1 relative ${isMobile ? 'pt-[60px]' : ''}`}>
                {children}
              </div>
              
              {/* Horizontal line that spans full width - positioned absolutely (desktop only) */}
              {!isMobile && (
                <div className="absolute left-0 right-0 top-[88px] h-px bg-borderGrey pointer-events-none"></div>
              )}
            </div>
          )}
        </>
      ) : (
        <div className="min-h-screen">
          {children}
        </div>
      )}
      <div id="portal" />
      <div id="banner" />
    </div>
  );
};

export default RootLayout;
